<template>
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0 max-h-0 overflow-hidden"
    enter-to-class="opacity-100 max-h-96 overflow-visible"
    leave-active-class="transition-all duration-300 ease-in"
    leave-from-class="opacity-100 max-h-96 overflow-visible"
    leave-to-class="opacity-0 max-h-0 overflow-hidden"
  >
    <template v-if="show">
      <div v-if="titles.length">
        <SectionDivider />
        <div
          v-for="title in titles"
          :key="title.label.split(' ').join('-').toLocaleLowerCase()"
          class="h-auto my-4 flex flex-col gap-4"
        >
          <div class="flex flex-row">
            <div class="flex-1 text-left">
              <p class="text-grey-light-900 text-sm">{{ title.label }}</p>
            </div>
            <span
              class="font-semibold text-sm"
              :class="{ 'text-grey-light-900': !title.grey, 'text-grey-light-600': title.grey }"
            >
              {{ title.value }}
            </span>
          </div>
        </div>
        <SectionDivider />
        <div class="my-2.5">
          <div class="flex flex-row py-2" v-for="payment in payments" :key="payment.id">
            <div class="flex-1 text-left">
              <p class="text-grey-light-900 text-sm">{{ payment?.due }}</p>
            </div>
            <div class="font-bold">
              <span class="text-sm text-grey-light-900 font-semibold">{{ payment?.amount }}</span>
            </div>
          </div>
        </div>
      </div>
      <p v-else class="text-center text-grey-light-600">No payment breakdown available.</p>
    </template>
  </Transition>
</template>

<script setup lang="ts">
import SectionDivider from '@/components/common/SectionDivider.vue';
import type { ScheduleBreakdownPayment } from '../payments-breakdown.types';

defineProps<{
  show: boolean;
  titles: Array<{ label: string; value: string; grey: boolean }>;
  payments: Array<ScheduleBreakdownPayment>;
}>();
</script>
